(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-card"] && !Shopify.designMode) return;
  try {
    (() => {

    if (window.rejsellFeatureDisclosureInstalled) return;

    window.rejsellFeatureDisclosureInstalled = true;

    let nextId = 0;

    document.addEventListener('click', event => {

      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('.rejsell-feature-toggle');

      if (!button) return;

      const panel = button.nextElementSibling;

      if (!panel?.classList.contains('rejsell-feature-panel')) return;

      event.preventDefault();

      event.stopPropagation();

      if (!panel.id) {

        do { nextId++; } while (document.getElementById('rejsell-feature-panel-' + nextId));

        panel.id = 'rejsell-feature-panel-' + nextId;

      }

      button.setAttribute('aria-controls', panel.id);

      const expanded = button.getAttribute('aria-expanded') !== 'true';

      button.setAttribute('aria-expanded', String(expanded));

      panel.setAttribute('aria-hidden', String(!expanded));

      panel.classList.toggle('is-open', expanded);

    }, true);

    document.addEventListener('keydown', event => {

      if (event.target instanceof Element && event.target.closest('.rejsell-feature-toggle') &&

          (event.key === 'Enter' || event.key === ' ')) event.stopPropagation();

    }, true);

  })();




  (() => {
    if (window.rejsellMenuAjaxCartInstalled) return;
    window.rejsellMenuAjaxCartInstalled = true;

    function updateHeader(cart) {
      document.querySelectorAll('.rj-cart-count').forEach(el => { el.textContent = `(${cart.item_count})`; });
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: cart.currency || 'EUR'
      }).format(cart.total_price / 100);
      document.querySelectorAll('.rj-cart-total').forEach(el => { el.textContent = formatted; });
      document.querySelectorAll('cart-icon').forEach(icon => {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(cart.item_count, false);
        } else {
          const count = icon.querySelector('[ref="cartBubbleCount"]');
          if (count) {
            count.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
            count.classList.toggle('hidden', cart.item_count === 0);
          }
          icon.querySelector('[ref="cartBubble"]')?.classList.toggle('visually-hidden', cart.item_count === 0);
          icon.classList.toggle('header-actions__cart-icon--has-cart', cart.item_count > 0);
        }
      });
      try {
        sessionStorage.setItem('cart-count', JSON.stringify({value: String(cart.item_count), timestamp: Date.now()}));
      } catch (_) {}
    }

    function refreshClosedDrawers(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      Object.values(sections).forEach(html => {
        if (typeof html !== 'string') return;
        const fresh = parser.parseFromString(html, 'text/html');
        fresh.querySelectorAll('cart-drawer-component').forEach(newDrawer => {
          const newItems = newDrawer.querySelector('cart-items-component');
          const newDialog = newDrawer.querySelector('dialog');
          if (!newItems || !newDialog) return;
          document.querySelectorAll('cart-drawer-component').forEach(drawer => {
            const items = drawer.querySelector('cart-items-component');
            const dialog = drawer.querySelector('dialog');
            if (!items || !dialog || dialog.open) return;
            if (items.dataset.sectionId !== newItems.dataset.sectionId) return;
            items.replaceWith(newItems.cloneNode(true));
            dialog.classList.toggle('cart-drawer--empty', newDialog.classList.contains('cart-drawer--empty'));
            const label = newDialog.getAttribute('aria-labelledby');
            if (label) dialog.setAttribute('aria-labelledby', label);
          });
        });
      });
    }


    // Capture clicks so product-card links and search handlers cannot navigate instead.
    document.addEventListener('click', async event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-rj-search-cart]');
      if (!button || !button.closest('predictive-search-component')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
      const label = button.querySelector('[data-rj-search-cart-label]');
      const status = button.closest('.rejsell-menu-footer')?.querySelector('.rejsell-menu-cart-status');
      const originalText = label?.textContent || 'In den Warenkorb';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Wird hinzugefügt …';
      if (status) status.textContent = '';
      let added = false;
      try {
        const data = new FormData();
        data.set('id', button.dataset.variantId);
        data.set('quantity', button.dataset.quantity || '1');
        const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-drawer-component cart-items-component[data-section-id]'), el => el.dataset.sectionId))].filter(Boolean).slice(0, 5);
        if (sectionIds.length) {
          data.set('sections', sectionIds.join(','));
          data.set('sections_url', window.location.pathname);
        }
        const endpoint = new URL(button.dataset.cartAddUrl, window.location.href);
        endpoint.pathname = endpoint.pathname.replace(/\/add(?:\.js)?$/, '/add.js');
        const response = await fetch(endpoint.href, {
          method: 'POST', body: data, credentials: 'same-origin',
          headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Der Artikel konnte nicht hinzugefügt werden.');
        added = true;
        if (label) label.textContent = 'Hinzugefügt ✓';
        if (status) status.textContent = 'Artikel wurde in den Warenkorb gelegt.';
        try { refreshClosedDrawers(result.sections); }
        catch (error) { console.warn('REJSELL: Warenkorbinhalt konnte nicht aktualisiert werden.', error); }
        const cartUrl = new URL(endpoint.href);
        cartUrl.pathname = cartUrl.pathname.replace(/\/add\.js$/, '.js');
        const cartResponse = await fetch(cartUrl.href, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!cartResponse.ok) throw new Error('Warenkorbanzeige konnte nicht aktualisiert werden.');
        updateHeader(await cartResponse.json());
      } catch (error) {
        if (status) status.textContent = added
          ? 'Artikel hinzugefügt. Die Warenkorbanzeige konnte noch nicht aktualisiert werden.'
          : (error.message || 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.');
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label && !added) label.textContent = originalText;
        if (label && added) setTimeout(() => {
          if (button.getAttribute('aria-busy') !== 'true') label.textContent = originalText;
        }, 1800);
      }
    }, true);

    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.rejsell-menu-cart-form')) return;
      if (!form.closest('.mega-menu__content-list--products')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.getAttribute('aria-busy') === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const label = button.querySelector('[data-rejsell-cart-button-label]');
      const status = form.closest('.rejsell-menu-footer')?.querySelector('.rejsell-menu-cart-status');
      const originalText = label?.textContent || 'In den Warenkorb';
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (label) label.textContent = 'Wird hinzugefügt …';
      if (status) status.textContent = '';
      let added = false;
      try {
        const data = new FormData(form);
        const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-drawer-component cart-items-component[data-section-id]'), el => el.dataset.sectionId))].filter(Boolean).slice(0, 5);
        if (sectionIds.length) {
          data.set('sections', sectionIds.join(','));
          data.set('sections_url', window.location.pathname);
        }
        const endpoint = new URL(form.action, window.location.href);
        endpoint.pathname = endpoint.pathname.replace(/\/add(?:\.js)?$/, '/add.js');
        const response = await fetch(endpoint.href, {
          method: 'POST', body: data, credentials: 'same-origin',
          headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Der Artikel konnte nicht hinzugefügt werden.');
        added = true;
        if (label) label.textContent = 'Hinzugefügt ✓';
        if (status) status.textContent = 'Artikel wurde in den Warenkorb gelegt.';
        // Refresh only cart contents, never open a drawer or navigate away.
        try { refreshClosedDrawers(result.sections); } catch (error) { console.warn('REJSELL: Warenkorbinhalt konnte nicht aktualisiert werden.', error); }
        const cartUrl = new URL(endpoint.href);
        cartUrl.pathname = cartUrl.pathname.replace(/\/add\.js$/, '.js');
        const cartResponse = await fetch(cartUrl.href, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!cartResponse.ok) throw new Error('Warenkorbanzeige konnte nicht aktualisiert werden.');
        updateHeader(await cartResponse.json());
      } catch (error) {
        if (status) status.textContent = added
          ? 'Artikel hinzugefügt. Die Warenkorbanzeige konnte noch nicht aktualisiert werden.'
          : (error.message || 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.');
      } finally {
        form.removeAttribute('aria-busy');
        button.disabled = false;
        if (label && !added) label.textContent = originalText;
        if (label && added) setTimeout(() => { if (form.getAttribute('aria-busy') !== 'true') label.textContent = originalText; }, 1800);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
